export let OAuthProviders;

(function (OAuthProviders) {
  OAuthProviders["Microsoft"] = "microsoft";
  OAuthProviders["Google"] = "google";
  OAuthProviders["Wordpress"] = "wordpress";
  OAuthProviders["Apple"] = "apple";
  OAuthProviders["LinkedIn"] = "linkedin";
  OAuthProviders["PayPal"] = "paypal";
})(OAuthProviders || (OAuthProviders = {}));